module.exports = __webpack_public_path__ + "static/media/37.44765ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/37.jpg
// module id = 297
// module chunks = 0